export function sendJson(socket, message) {
  if (!socket || socket.readyState !== 1) return false;
  socket.send(JSON.stringify(message));
  return true;
}

export function createRequestId(prefix = 'req', cryptoImpl = globalThis.crypto) {
  if (cryptoImpl?.randomUUID) return cryptoImpl.randomUUID();
  return prefix + '_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
}
